/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TreatmentTopic } from './treatmentTopic';
import { Practice } from './practice';
import { TreatmentApproach } from './treatmentApproach';


/**
 * Serializer for the TherapistProfile model.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface TherapistProfile { 
    readonly id: number;
    readonly name: string;
    readonly userId: number;
    readonly appointmentResourceId: number | null;
    readonly email: string;
    readonly isActive: boolean;
    practices: Array<Practice>;
    treatmentApproaches: Array<TreatmentApproach>;
    treatmentTopics: Array<TreatmentTopic>;
    blacklistedTreatmentTopics: Array<TreatmentTopic>;
}
export const TherapistProfile_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_name_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_userId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_appointmentResourceId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_email_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_isActive_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_practices_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_treatmentApproaches_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_treatmentTopics_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TherapistProfile_blacklistedTreatmentTopics_Validators: ValidatorFn[] =
    [  Validators.required, ];


